import { Skeleton } from "antd";
import { useState } from "react";
import ReactPlayer from "react-player/youtube";
import styles from "./VideoCard.module.scss";

const VideoCard = ({ videoUrl }) => {
  const [ready, setReady] = useState(false);

  return (
    <div className={styles["video-card"]}>
      <div style={{ display: ready ? "flex" : "none", width: "100%" }}>
        <ReactPlayer
          width={"100%"}
          height={window.screen.width < 480 ? "150px" : "225px"}
          url={videoUrl}
          controls={true}
          onReady={() => setReady(true)}
        />
      </div>
      {!ready && (
        <div
          className={styles["video-loader"]}
          style={{
            width: "100%",
            height: window.screen.width < 480 ? "150px" : "225px",
          }}
        >
          <Skeleton.Input active />
        </div>
      )}
    </div>
  );
};

export default VideoCard;
